import { getContestApiHost } from "../../../Api/Utils/apiUtils"
import { CONTENT_TYPE, HEADERS, METHOD } from "../../Const/const";
const qs = require('qs');

class RawApi {
    isLoading = false
    contestApiHost = getContestApiHost()

    async post(endpoint, payload, contentType){
        let headers = {}
        let requestBody;
        if (contentType === CONTENT_TYPE.JSON) {
            requestBody = payload
        }else if(contentType === CONTENT_TYPE.MULTIPART){
            requestBody = new FormData();
            for (const name in payload) {
                requestBody.append(name, payload[name])
            }
        }else if(contentType === CONTENT_TYPE.URLENCODED){
            requestBody = qs.stringify(payload);
        }else if (!contentType) {
            const params = qs.stringify(payload)
            endpoint = `${endpoint}?${params}`
        }

        if (contentType !== CONTENT_TYPE.MULTIPART) {
            headers[HEADERS.CONTENT_TYPE] = contentType
        }
        return this.rawFetch(endpoint, METHOD.POST, requestBody, headers)
    }

    
    async rawFetch(endpoint, method, payload, headersOptions){
        const headers = {
            [HEADERS.ACCEPT]: CONTENT_TYPE.JSON,
            [HEADERS.CACHE_CONTROL]: 'no-store',
            [HEADERS.PRAGMA]: 'no-cache'
        }
        Object.keys(headersOptions).forEach((headerName) => {
            headers[headerName] = headersOptions[headerName]
        })
        const body = payload
        const options = {
            method,
            headers,
            body
        }
        this.isLoading = true
        const result = await fetch(this.contestApiHost + endpoint, options)
        const response = await this.descriveResponse(result)
        this.isLoading = false
        return response
    }

    async descriveResponse(responseData){
        try {
            const payload = JSON.parse(await responseData.text())
            return payload
        } catch (error) {
            if (responseData.status === 402 || responseData.status === 202) {
                return {}
            }else{
                return {
                    status: 500,
                    error: true,
                    message: 'Internal server error'
                }
            }
        }
    }
}

export default RawApi